import { render, staticRenderFns } from "./OrderUpdatePaymentShipping.vue?vue&type=template&id=035c5557"
import script from "./OrderUpdatePaymentShipping.vue?vue&type=script&lang=js"
export * from "./OrderUpdatePaymentShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports